import React, {Component} from 'react'
import {Modal, Table, TableHeader, TableBody, TableRow, TableHeaderCell, Label, TableCell, Button} from 'semantic-ui-react'

const singleSizes = [
    "XXS",
    'XS',
    'S',
    "S/M",
    'M',
    'L',
    "L/XL",
    'XL',
    '1XL',
    '2XL',
    '1X',
    '2X',
    '3X',
    "4X",
    "5X",
    '2X/3X',
    'XXL',
    'XXXL',
    '30A',
    '32A',
    '34A',
    '34B',
    '34C',
    '36B',
    '36C',
    '36D',
    '36DD',
    '38C',
    '38D',
    '38DD',
    '40C',
    '40D',
    '40DD',
    '42C',
    '42D',
    '2T',
    '3T',
    '4T',
    "0", "1",
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    "11",
    '12',
    "13",
    '14',
    '6-9 mo',
    '12 mo',
    '18 mo',
    '0M',
    '3M',
    '6M',
    '9M',
    '12M',
    '18M',
    "A",
    "B",
    "C",
    "D",
    "ONE SIZE",
    "JUNIOR ONE SIZE",
    "34B/S",
    "34C/M",
    "36B/M",

   "14/16", "15", "16",
  "17", "18", "18/20", "19", "20", "21", "22", "22/24", "23", "24",
  "25", "26", "26/28", "27", "28", "29", "30", "30/32",
  "31", "32", "33", "34", "35", "36", "36C/L",
  "36DD/1X", "37", "38", "38C/XL", "38D/1X", "38DD/2X", "39",
  "40", "40D/2X", "40DD/3X", "41", "42", "42D/3X", "43", "44", "45", "46",
  "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57",
  "58", "59", "60",
  "FULL/QUEEN",
  "KING",
  '0X',
  "P",
  "SMALL",
  "MEDIUM",
  "LARGE"
]



class LaFashionTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render () {
    let {cad, open, onClose} = this.props
    let {available} = cad

    let sizes = available.map(x => x.size)
    let uniqueSizes = [...new Set(sizes)]
    uniqueSizes = uniqueSizes.sort((a, b) => singleSizes.indexOf(a) - singleSizes.indexOf(b))

    let colors = available.map(x => x.color)
    let uniqueColors = [...new Set(colors)]

    let header = [null].concat(uniqueSizes)
    let tableData = []

    uniqueColors.forEach((color) => {
      let row = [color]

      uniqueSizes.forEach((size) => {
        let val = available.find(x => x.size == size && x.color == color)
        if (val == null) {
          row.push(null)
        } else {
          row.push(val.available)
        }
      })
      tableData.push(row)
    })

    return (
      <Modal size='large' open={open} onClose={onClose} closeIcon>
        <Modal.Header>{cad.s}</Modal.Header>
        <Modal.Content>
          <Table celled>
            <TableHeader>
              <TableRow>
                {
                  header.map(x => <TableHeaderCell>{x}</TableHeaderCell>)
                }
              </TableRow>
            </TableHeader>

            <TableBody>
              {
                tableData.map((row) =>
                  <TableRow>
                    {
                      row.map(x => <TableCell>{x}</TableCell>)
                    }
                  </TableRow>
                )
              }
            </TableBody>
          </Table>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose} primary>
            Done
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default LaFashionTable
